import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const FontFieldHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`

export const FontList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const MobileFontList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 16px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const FontItemRow = styled.div<{
  $isActive?: boolean
  $noHover?: boolean
}>`
  background: ${({ $isActive }) =>
    $isActive ? COLORS.primaryLight : COLORS.white};
  padding: 17px;
  display: flex;
  justify-content: space-between;
  transition: background 0.2s;
  border-radius: 4px;
  align-items: center;
  height: 48px;
  cursor: pointer;

  ${({ $noHover }) =>
    $noHover &&
    css`
      padding: 0;
      height: 38px;
    `}

  &:hover {
    background: ${({ $isActive, $noHover }) =>
      $noHover
        ? $isActive
          ? COLORS.primaryLight
          : COLORS.white
        : $isActive
          ? COLORS.primaryLight
          : COLORS.secondaryUltraLight};
  }
`

export const FontImg = styled.img<{ $dimmed?: boolean }>`
  max-width: 90%;
  height: 15px;
  object-fit: contain;
  object-position: left center;
  opacity: ${({ $dimmed }) => ($dimmed ? 0.3 : 1)};
  transition: opacity 0.2s;
`

/** Full-width trigger row so flex layout does not jump when spinner mounts. */
export const FontDropdownTriggerRow = styled(FontItemRow)`
  width: 100%;
  min-width: 0;
  justify-content: flex-start;
`

export const FontHeaderLabel = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

/** Fixed slot so spinner show/hide does not change flex item count or widths. */
export const FontHeaderSpinnerSlot = styled.div`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`
